/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_DispatchInputs */

const en_confirm_dispatch = /** @type {(inputs: Confirm_DispatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm Dispatch`)
};

const es_confirm_dispatch = /** @type {(inputs: Confirm_DispatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar Envío`)
};

const fr_confirm_dispatch = /** @type {(inputs: Confirm_DispatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmer l'expédition`)
};

const de_confirm_dispatch = /** @type {(inputs: Confirm_DispatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versand bestätigen`)
};

const id_confirm_dispatch = /** @type {(inputs: Confirm_DispatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfirmasi Pengiriman`)
};

/** @type {(inputs: Confirm_DispatchInputs) => LocalizedString} */
const ja_confirm_dispatch = en_confirm_dispatch;

/** @type {(inputs: Confirm_DispatchInputs) => LocalizedString} */
const zh_confirm_dispatch = en_confirm_dispatch;

/** @type {(inputs: Confirm_DispatchInputs) => LocalizedString} */
const ar_confirm_dispatch = en_confirm_dispatch;

/** @type {(inputs: Confirm_DispatchInputs) => LocalizedString} */
const it_confirm_dispatch = en_confirm_dispatch;

/** @type {(inputs: Confirm_DispatchInputs) => LocalizedString} */
const ru_confirm_dispatch = en_confirm_dispatch;

/** @type {(inputs: Confirm_DispatchInputs) => LocalizedString} */
const pt_confirm_dispatch = en_confirm_dispatch;

/** @type {(inputs: Confirm_DispatchInputs) => LocalizedString} */
const ko_confirm_dispatch = en_confirm_dispatch;

/**
* | output |
* | --- |
* | "Confirm Dispatch" |
*
* @param {Confirm_DispatchInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const confirm_dispatch = /** @type {((inputs?: Confirm_DispatchInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_DispatchInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_confirm_dispatch(inputs)
	if (locale === "es") return es_confirm_dispatch(inputs)
	if (locale === "fr") return fr_confirm_dispatch(inputs)
	if (locale === "de") return de_confirm_dispatch(inputs)
	if (locale === "ja") return ja_confirm_dispatch(inputs)
	if (locale === "zh") return zh_confirm_dispatch(inputs)
	if (locale === "ar") return ar_confirm_dispatch(inputs)
	if (locale === "id") return id_confirm_dispatch(inputs)
	if (locale === "it") return it_confirm_dispatch(inputs)
	if (locale === "ru") return ru_confirm_dispatch(inputs)
	if (locale === "pt") return pt_confirm_dispatch(inputs)
	return ko_confirm_dispatch(inputs)
});